import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import ACSHelper from "./ACSHelper";
import { SignInButton } from "./SignInButton";
import { mergeStyles, Stack, Text } from "@fluentui/react";
import {  containerTokens } from "../styles/HomeScreen.styles";
import { useEffect, useState } from "react";
import { FontSizes } from '@fluentui/theme';
import { useGlobalState } from "../utils/GlobalState";

const Login = (): JSX.Element => {
  const [color, setColor] = useState("");
  const { state } = useGlobalState();
  
  function setMeetingId() {        
    const params = new URLSearchParams(window.location.search);
    const key = "meetingId";
    if(params.has(key)) {
        let id = params.get(key)!;                  
        localStorage.setItem("meetingId", id);          
        window.history.replaceState({}, document.title, "/");
    }
  }
    
  useEffect(() => {            
    setMeetingId();
    const recordingID = state.meetingId;
    if (recordingID && recordingID?.length < 0) {
      setColor("red");
    } else {
      setColor("white");
    }
  }, []);

  const containerStyles = mergeStyles({
    height: "100%",
    width: "100% ",
    padding: "2rem", //half childrenGap from Stack
    minWidth: "24rem", // max of min-width from stack items + padding * 2 = 20 + 2 * 2
    minHeight: "auto",
    background :color,
    backgroundColor :color,
  });

  return (
    <Stack
      horizontal
      horizontalAlign="center"
      verticalAlign="center"
      className={containerStyles}
      tokens={containerTokens}
    >
      <AuthenticatedTemplate>
        <ACSHelper />
      </AuthenticatedTemplate>

       <UnauthenticatedTemplate>

        <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >

        <div style={{ fontSize: FontSizes.size42 }} >
        Welcome to HSC Language Oral Exams
        </div>
        
      
        <div style={{
          marginTop : 30,
          marginBottom : 30
        }} >
         <SignInButton />
        </div>

      </div>
      </UnauthenticatedTemplate>
       
    </Stack>
  );
};

export default Login;
